jQuery(function($){
    var official_id = $("#official-id").text();

    if(official_id){
        var targetURL = "https://sanei-sangyo.jp/wp-json/wp/v2/products/" + official_id;
   
        $.ajax({
            type: 'GET',
            url: targetURL,
            dataType: 'text',
            timeout: 30000,
            success: function(res){            
                var data = JSON.parse(res);            
                var meta = data["products_meta2"]; 

                if(notEmpty(data["content"]["rendered"])) {
                    $("#wprestapi_product_description").html(data["content"]["rendered"]);
                }
                if(notEmpty(meta["catchphrase"])) {
                    $("#product-catchcopy").text(meta["catchphrase"]);
                }
                if(notEmpty(meta["post_thumbnail"])){
                    //console.log(meta["post_thumbnail"]);
                }


                
                if(notEmpty(meta["useterm_str"])){
                    $("#isset_use").removeClass("hide");
                    $("#product_taxonomy div.use").text(meta["useterm_str"]);
                }
                if(notEmpty(meta["sizeterm_str"])){
                    $("#isset_size").removeClass("hide");
                    $("#product_taxonomy div.size").text(meta["sizeterm_str"]);
                }
                if(notEmpty(meta["gyoukaiterm_str"])){
                    $("#isset_gyoukai").removeClass("hide");
                    $("#product_taxonomy div.gyoukai").text(meta["gyoukaiterm_str"]);
                }            
                if(notEmpty(meta["keyterm_str"])){
                    $("#isset_key").removeClass("hide");
                    $("#product_taxonomy div.key").text(meta["keyterm_str"]);
                }
                if(notEmpty(meta["moneycount"])){
                    $("#isset_money").removeClass("hide");
                    $("#product_taxonomy div.money").html(meta["moneycount"]);
                }
                if(notEmpty(meta["materials"])){
                    $("#isset_materials").removeClass("hide");
                    $("#product_taxonomy div.materials").html(meta["materials"]);
                }
                if(notEmpty(meta["explain_css"])){
                    var style = "<style>" + meta["explain_css"] + "</style>";
                    $("#product_explain_area").before(style);
                 }
     
                 if(notEmpty(meta["product_explain"])){
                     $("#product_explain_area").removeClass("hide");
                     $("#product_explain_area div.inner").append(meta["product_explain"]);
                 }

                var oimg_arr = meta["outer_images_pc"];
                $("ul.product__media-list").empty();
                var $oimg_area = $("ul.product__media-list");
                for(var i = 0 ; i < oimg_arr.length; i++){
                    $oimg_area.prepend(oimg_arr[i]);
                }

                if(notEmpty(meta["product_key"])){
                    $("#product_key_area").removeClass("hide");
                    var pkey_arr = meta["product_key"];
                    var $pkey_area = $("#normal_keys");
                    for(var i = 0 ; i < pkey_arr.length; i++){
                        $pkey_area.prepend(pkey_arr[i]);
                    }
                }
               
                if(notEmpty(meta["product_key_special"])){                
                    $(".isset_skey").removeClass("hide");
                    var skey_arr = meta["product_key_special"];
                    var $skey_area = $("#special_keys");
                    for(var i = 0 ; i < skey_arr.length; i++){
                        $skey_area.prepend(skey_arr[i]);
                    }
                }
    
                $("#psize_img").html(meta["product_size_single"]);
                $("#psize_txt").html(meta["product_size"]);

                var ncol_arr = meta["normal_colors"];
                var $ncol_area = $("#n_colors");
                for(var i = 0 ; i < ncol_arr.length; i++){
                    $ncol_area.prepend(ncol_arr[i]);
                }
    
                if(notEmpty(meta["special_colors"])){
                    $(".isset_scol").removeClass("hide");
                    var scol_arr = meta["special_colors"];
                    var $scol_area = $("#s_colors");
                    for(var i = 0 ; i < scol_arr.length; i++){
                        $scol_area.prepend(scol_arr[i]);
                    }
                }
    
                $("#product_num").html(meta["product_info"]);

                $(".slider-counter--total").text(oimg_arr.length);
                
            
            },
            error: function(){
                // エラーハンドリング
            }
        });
    }

    
    
    function notEmpty(value) {
        var result;
        switch (typeof value) {
        case 'string':
            result = (value && value != 0);
            break;
        case 'object':
            result = (value && Object.keys(value).length);
            break;
        default:
            result = value;
        }
        return Boolean(result);
    }
});